<template>
    <div>
        <div v-if="isShowTender">
            <PosTender :summaryProp="summary" :orderItemsProp="orderItems" @addItem="addItem" @showTender="showTender" />
        </div>
        <div v-else>
            <PosSaleReceipt :summaryProp="summary" :orderItemsProp="orderItems" @addItem="addItem" @showTender="showTender" />
        </div>
    </div>
</template>

<script>
    import PosSaleReceipt from './Component/PosSaleReceipt';
    import PosTender from './Component/PosTender';
    export default {
        components: {
            PosSaleReceipt,
            PosTender
        },
        data: function () {
            return {
                isShowTender: false,
                summary: {
                    SubTotal: 0,
                    Discount: 0,
                    Tax: 0,
                    GrandTotal: 0,
                    CustomerId: '',
                    CustomerName: this.$t('customer_name'),
                    PaymentReceive: '',
                    PaymentRefundUsd: 0,
                    PaymentRefundRiel: 0,
                    UntaxAmount: 0,
                    TotalAmount: 0,
                    PaidStatus: "Paid"
                },
                orderItems: []
            }
        },
        methods: {
            showTender(ret) {
                this.isShowTender = ret.isShowTender;
                this.summary = ret.summary;
                this.orderItems = ret.orderItems;
            },
            addItem(ret, isAdd = true) {
                const foundIndex = this.orderItems.findIndex(row => row.Id == ret.Id);
                if (foundIndex == -1) {
                    const item = JSON.parse(JSON.stringify(ret));
                    item.ItemId = item.Id;
                    item.Quantity = 1;
                    item.SubTotal = item.Price;
                    this.$set(this.orderItems, this.orderItems.length, item);
                }
                else {
                    const item = JSON.parse(JSON.stringify(this.orderItems[foundIndex]));
                    if (isAdd) {
                        item.Quantity += 1;
                    } else {
                        const qty = item.Quantity - 1;
                        if (qty >= 0) item.Quantity = qty;
                    }
                    item.SubTotal = item.Quantity * item.Price;
                    this.$set(this.orderItems, foundIndex, item);
                }

                this.sumTotal();
            },
            sumTotal() {
                let subTotal = 0;
                for (let i = 0; i < this.orderItems.length; i++) {
                    const item = this.orderItems[i];
                    subTotal += item.SubTotal;
                }

                this.$set(this.summary, 'SubTotal', subTotal);
                this.$set(this.summary, 'GrandTotal', subTotal);
            }
        }
    };
</script>
